import { useEffect, useState } from 'react'
import type { RefObject } from 'react'

const WORDS_PER_MINUTE = 200

/** Estimates reading time (in minutes) from the word count of the referenced element. */
export function useReadingTime(ref: RefObject<HTMLElement>): number {
  const [minutes, setMinutes] = useState(1)

  useEffect(() => {
    const text = ref.current?.textContent ?? ''
    const words = text.trim().split(/\s+/).filter(Boolean).length
    setMinutes(Math.max(1, Math.ceil(words / WORDS_PER_MINUTE)))
  }, [ref])

  return minutes
}
